import React, { Component } from 'react';
import MainText from './MainText';
import { connect } from 'react-redux';
import Toolbar from './Toolbar';
import ImageDiv from './ImageDiv';
import VideoDiv from './VideoDiv';
class TextImageSammy extends Component {
    render() {
        return (
            <div className="layout-page">
                {/* this scene has a title, some action buttons, stored in an array, with type data, visual elements (how many? what type?) stored in an array, with type data, and data about next available scenes, stored in an array */}
                <div className="flex-box flex-center">

                    <div className="column-lg-10 column-md-12 column-sm-12">
                    {this.props.activeScene.title !== null && <h2><span className="title">{this.props.activeScene.title}</span></h2>} 
                    </div>
                </div>
                <div className="flex-box flex-center">
                {this.props.activeScene.text.length > 0 && <div className="column-lg-5 column-md-12 column-sm-12 text-spotlight flex-column flex-center">
                                <MainText className={`text-light-div `} text={this.props.activeScene.text[0]}/>
                    </div>}
                    {this.props.activeScene.images.map((image, i) => {
                        return (<ImageDiv columns={`column-lg-5 column-md-12 column-sm-12`} divClass={`image-space`} image={image} key={i}/>);
                    })} 
                          {this.props.activeScene.text.length > 1 && <div className="flex-box flex-end "><div className="column-lg-6 column-md-12 column-sm-12 text-spotlight">
                      <MainText className={`text-shadow `} text={this.props.activeScene.text[1]}/>
                      </div></div>}
                      {this.props.activeScene.videos.map((video, i) => {
                        return (<VideoDiv className={`column-lg-5 column-sm-12 column-md-12`} video={video} key={i}/>);
                    })}
                    </div> 
                <Toolbar history={this.props.history}/>
            </div>

        );
    }
}
const mapStateToProps = state => ({
    activeScene: state.activeScene
})
export default connect(mapStateToProps)(TextImageSammy);